export default "__VITE_ASSET__tW_jzAuS__"